import { useAnalytics } from '../hooks/useAnalytics';

/**
 * Wrapper component to enable analytics tracking throughout the app
 */
const AnalyticsWrapper = ({ children }) => {
  useAnalytics(); // Auto-track page views
  return children;
};

export default AnalyticsWrapper;
